<template>
  <div class="guideViewH5">
    <HeaderTopSwiper />
    <div class="guideViewH5-content">
      <div class="content">
        <div class="content-images-wrapper">
          <div
            v-for="(row, rowIndex) in visibleImages"
            :key="rowIndex"
            class="image-row-wrapper"
          >
            <div
              class="image-row"
              ref="dynamicRefs"
              :style="rowIndex === 1 ? { top: '-60px' } : {top: '-30px'}"
            >
              <img
                v-for="(image, index) in row"
                :key="index"
                :src="image"
                width="120px"
                alt="image"
                class="image-item"
              >
            </div>
          </div>
        </div>
        <div class="content-bg" />
        <img
          src="@/assets/guide/group-logo.png"
          alt=""
          class="content-logo"
        >
      </div>
      <div class="guide-title">
        Your Gateway to Unlimited Goods!
      </div>
      <div class="guide-desc">
        Discover billions of products for your needs.
      </div>
      <div
        class="guide-sign-btn"
        @click="handleSign"
      >
        Sign in / Sign up
      </div>
      <CouponBanner
        class="coupon-banner"
        @click="handleSign"
      />
    </div>
  </div>
</template>

<script setup>
import HeaderTopSwiper from '@/views/HomeView/components/HomeViewH5/components/HeaderTopSwiper/index.vue'
import { useRoute } from 'vue-router'
import { useLoginModal } from '@/components/Login'
import CouponBanner from '../CouponBanner/index.vue'

const route = useRoute()

const { open: openLoginModal } = useLoginModal()

const group1 = import.meta.glob('@/assets/guide/group1/*.webp', {
  eager: true
})
const group2 = import.meta.glob('@/assets/guide/group2/*.webp', {
  eager: true
})
const group3 = import.meta.glob('@/assets/guide/group3/*.webp', {
  eager: true
})

const visibleImages = ref([])
const dynamicRefs = ref([])
const innerHeight = ref(0)
onMounted(() => {
  innerHeight.value = window.innerHeight
  visibleImages.value = [
    mapImages(group1),
    mapImages(group2),
    mapImages(group3)
  ]
  setInterval(() => {
    startImageTransition()
  }, 5000)
})

const mapImages = (group) => {
  const images = []
  for (const path in group) {
    images.push(group[path].default)
  }
  return images
}

const handleSign = () => {
  openLoginModal()
}

const transformNums = ref(0) // 位移次数
const startImageTransition = () => {
  transformNums.value++
  if (transformNums.value > 2) {
    transformNums.value = 0
  }
  const elList = dynamicRefs.value
  elList.forEach((el, index) => {
    setTimeout(() => {
      el.style.opacity = 0
      el.style.transform = `translateY(${-456 * transformNums.value}px)`

      setTimeout(() => {
        el.style.opacity = 1
      }, 300)
    }, 800 * index)
  })
}

const handleSuperUser = () => {
  const query = route.query
  if (+query.sp === 1) {
    /**
     * 超级用户清理旧信息
     */
    localStorage.clear()
    handleSign()
  }
}

onMounted(() => {
  handleSuperUser()
})

</script>

<style>
@import "./index.less";
</style>
